<template>
  <div class="contact-us full-screen">
    <div class="wrapper wrapper-full-page section content bg-secondary">
      <div class="container">
        <div class="row">
          <div class="col-12 col-md-8 offset-md-2 col-lg-6 offset-lg-3">
            <div class="mt-5 d-flex justify-content-center">
              <div class="card">
                <div class="card-body">
                  <h1 class="card-title mb-4" style="font-size: 1.75em;">Eπαναφορά κωδικού λογαριασμού</h1>
                  <div class="form-group">
                    <label class="control-label" for="password_input">Νέος Κωδικός</label>
                    <input class="form-control" id="password_input" type="password" autocomplete="off" v-model.trim="password" required>
                  </div>
                  <div class="form-group">
                    <label class="control-label" for="password2_input">Επαλήθευση νέου κωδικού</label>
                    <input class="form-control" id="password2_input" type="password" autocomplete="off" v-model.trim="password2" required>
                  </div>
                </div>
                <div class="card-footer">
                  <div class="text-center">
                    <button class="btn btn-block btn-success" @click="reset" :disabled="loading">Επαναφορα<span v-if="loading">...</span></button>
                    <div v-if="errorMsg !== ''" class="text-danger mt-1">{{ errorMsg }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Api from "../api";
export default {
  data() {
    return {
      token: this.$route.params.token,
      password: "",
      password2: "",
      errorMsg: "",
      loading: false
    };
  },
  methods: {
    reset () {
      this.errorMsg = "";
      if (!this.token || this.token === "") {
        this.errorMsg = 'Ο σύνδεσμος έχει λήξει';
        return false;
      }
      if (this.password === "" || this.password2 === "") {
        this.errorMsg = "Όλα τα πεδία είναι υποχρεωτικά";
        return false;
      }
      if (this.password2 !== this.password) {
        this.errorMsg = "Ο κωδικός επαλήθευσης δεν είναι ο ίδιος";
        return false;
      }

      this.loading = true;
      Api.send2("POST", "/user/reset/password", {password: this.password}, this.token)
      .then((response) => {
        this.errorMsg = "";
        this.$router.push({name: 'reset_password_success'})
      })
      .catch((err) => {
        if (err.code === 400) {
          this.errorMsg = err.msg;
        } else {
          this.errorMsg = 'Ο σύνδεσμος έχει λήξει';
        }
      })
      .finally(() => {
        this.loading = false;
      });
    },
  },
};
</script>
<style></style>
